import type { AnimationsBehavior } from '@wix/thunderbolt-becky-types'
import type {
	CompInfo,
	BackgroundMedia,
	BackgroundMediaFillLayerCSSVars,
	MediaContainerDefinition,
} from '@wix/thunderbolt-components-native'
import { hasBackgroundScrubEffect, isMediaFullScreenByEffect, getBgMediaEffectName } from '../Media/Media.utils'

export const shouldRenderBackgroundMediaLayer = ({
	animations,
	viewMode,
}: Pick<CompInfo, 'viewMode'> & {
	animations: Array<AnimationsBehavior>
}) => {
	return (
		getBgMediaEffectName({ animations, viewMode }) ||
		isMediaFullScreenByEffect({
			animations,
			viewMode,
		})
	)
}

export const getMediaTransformsCSSVars = ({
	compDesign,
	backgroundMedia,
}: Pick<CompInfo, 'compDesign'> & {
	backgroundMedia: BackgroundMedia
}) => {
	const scaleBehavior = (compDesign as MediaContainerDefinition['design'])?.dataChangeBehaviors?.find(
		(item) => item.name === 'Scale'
	)
	return {
		'--scale': backgroundMedia.mediaTransforms?.scale,
		'--transform-duration': scaleBehavior?.params?.duration
			? `transform ${scaleBehavior.params.duration}s`
			: undefined,
	}
}

export const getBackgroundMediaFillLayerCSSVars = ({
	animations,
	viewMode,
}: Pick<CompInfo, 'viewMode' | 'isMobileView' | 'experiments'> & {
	animations: Array<AnimationsBehavior>
	isNonAdaptiveMobile: boolean
}): BackgroundMediaFillLayerCSSVars | undefined => {
	const shouldRenderBackgroundMedia = shouldRenderBackgroundMediaLayer({
		animations,
		viewMode,
	})
	if (!shouldRenderBackgroundMedia) {
		return
	}

	const hasBgScrubEffect = hasBackgroundScrubEffect({ animations, viewMode })
	const isFullScreenByEffect = isMediaFullScreenByEffect({
		animations,
		viewMode,
	})

	return {
		'--fill-layer-background-media-position': isFullScreenByEffect ? 'fixed' : 'absolute',
		'--fill-layer-background-media-pointer-events': hasBgScrubEffect ? 'none' : 'auto',
	} as const
}
